import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import styles from "./Register.module.css";

const API_URL = process.env.REACT_APP_API_URL;
const PAGE_BG = `${process.env.PUBLIC_URL}/fon.png`;

export default function ForgotPassword() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [email, setEmail] = useState("");
  const [stage, setStage] = useState("request");
  const [code, setCode] = useState("");
  const [newPass, setNewPass] = useState("");
  const [messageKey, setMessageKey] = useState("");
  const [error, setError] = useState("");

  const sendEmail = async () => {
    try {
      setError("");
      setMessageKey("");

      await axios.post(`${API_URL}/api/auth/forgot-password`, {
        email,
      });

      setMessageKey("profile.security.codeSent");
      setStage("code");
    } catch (e) {
      setError(
        e?.response?.data?.error ||
          e?.response?.data?.message ||
          t("club.errors.generic", "Ошибка")
      );
    }
  };

  const resetPass = async () => {
    try {
      setError("");
      setMessageKey("");

      await axios.post(`${API_URL}/api/auth/reset-password`, {
        email,
        code,
        newPassword: newPass,
      });

      setMessageKey("profile.security.passwordUpdated");

      setTimeout(() => {
        navigate("/login");
      }, 1200);
    } catch (e) {
      setError(
        e?.response?.data?.error ||
          e?.response?.data?.message ||
          t("club.errors.generic", "Ошибка")
      );
    }
  };

  return (
    <div
      className={`${styles.page} ${styles.forgotPage}`}
      style={{
        backgroundImage: `
          radial-gradient(900px 520px at 72% 12%, rgba(202,162,79,.08), transparent 60%),
          radial-gradient(780px 520px at 20% 85%, rgba(79,167,230,.08), transparent 60%),
          url(${PAGE_BG})
        `,
        backgroundRepeat: "no-repeat, no-repeat, no-repeat",
        backgroundSize: "auto, auto, cover",
        backgroundPosition: "center top, center bottom, center top",
      }}
    >
      <div
        className={styles.backgammonBackdrop}
        aria-hidden="true"
      />

      <main className={styles.authPage}>
        <div
          className={`${styles.card} ${styles.smallCard} ${styles.recoveryCard}`}
        >
          <div className={styles.brandBar}>
            BACKGAMMON QUEST
          </div>

          <form
            className={styles.form}
            onSubmit={(e) => e.preventDefault()}
          >
            <h2 className={styles.title}>
              {t("auth.forgotPassword")}
            </h2>

            {stage === "request" && (
              <>
                <div className={styles.group}>
                  <label htmlFor="forgot-email">
                    {t("auth.email")}
                  </label>

                  <input
                    id="forgot-email"
                    type="email"
                    placeholder={t(
                      "profile.security.emailPlaceholder"
                    )}
                    value={email}
                    onChange={(e) =>
                      setEmail(e.target.value)
                    }
                    autoComplete="email"
                  />
                </div>

                {error ? (
                  <div className={styles.error}>
                    {error}
                  </div>
                ) : null}

                {messageKey ? (
                  <div className={styles.helper}>
                    {t(messageKey)}
                  </div>
                ) : null}

                <button
                  type="button"
                  className={`${styles.primary} ${styles.smallBtn}`}
                  onClick={sendEmail}
                  disabled={!email.trim()}
                >
                  {t("profile.security.sendCode")}
                </button>

                <button
                  type="button"
                  className={`${styles.secondary} ${styles.smallBtn}`}
                  onClick={() => navigate("/login")}
                >
                  {t(
                    "bigTournaments.common.back",
                    "Назад"
                  )}
                </button>
              </>
            )}

            {stage === "code" && (
              <>
                <div className={styles.recoveryIntro}>
                  {t(
                    "profile.security.enterCodeAndPassword"
                  )}
                </div>

                <div className={styles.group}>
                  <label htmlFor="forgot-code">
                    {t(
                      "profile.security.codePlaceholder"
                    )}
                  </label>

                  <input
                    id="forgot-code"
                    type="text"
                    inputMode="numeric"
                    placeholder={t(
                      "profile.security.codePlaceholder"
                    )}
                    value={code}
                    onChange={(e) =>
                      setCode(e.target.value)
                    }
                    autoComplete="one-time-code"
                  />
                </div>

                <div className={styles.group}>
                  <label htmlFor="forgot-new-password">
                    {t(
                      "profile.security.newPasswordPlaceholder"
                    )}
                  </label>

                  <input
                    id="forgot-new-password"
                    type="password"
                    placeholder={t(
                      "profile.security.newPasswordPlaceholder"
                    )}
                    value={newPass}
                    onChange={(e) =>
                      setNewPass(e.target.value)
                    }
                    autoComplete="new-password"
                  />
                </div>

                {error ? (
                  <div className={styles.error}>
                    {error}
                  </div>
                ) : null}

                {messageKey ? (
                  <div className={styles.helper}>
                    {t(messageKey)}
                  </div>
                ) : null}

                <button
                  type="button"
                  className={styles.primary}
                  onClick={resetPass}
                  disabled={
                    !code.trim() ||
                    !newPass.trim()
                  }
                >
                  {t(
                    "profile.security.changePassword"
                  )}
                </button>

                <button
                  type="button"
                  className={styles.secondary}
                  onClick={() => {
                    setStage("request");
                    setError("");
                    setMessageKey("");
                  }}
                >
                  {t(
                    "bigTournaments.common.back",
                    "Назад"
                  )}
                </button>
              </>
            )}
          </form>
        </div>
      </main>
    </div>
  );
}
